/**
 * dependencies: src/BigInt_BigRat.min.js
 */

/**
 * Start of supporting functions
 */
// Check if native implementation available
if (typeof Object.create !== 'function') {
  Object.create = function (o) {
    function F() {}  // empty constructor
    F.prototype = o; // set base object as prototype
    return new F();  // return empty object with right [[Prototype]]
  };
}
function rationalize(rational, epsilon) {
  var denominator = 0, numerator, error;
  do {
    denominator++;
    numerator = Math.round((rational.numerator * denominator) / rational.denominator);
    error = Math.abs(rational.minus(numerator / denominator));
  } while (error > epsilon);
  return bigRat(numerator, denominator);
}
/**
 * End of supporting functions
 */


/**
 * Base Constructor class for common image-based products
 * Uses global variables:
 *  window.empty
 * @constructor
 */
function ConstructorRenderer(options) {
  this.empty = window.empty;
  this.forceImageRender = false;

  this.defaultOptions = $.extend(true, {}, {
    thumbSizeXY: [535, 535],
    orientation: 'Landscape',
    adjustComputedImageSize: true
  }, this.defaultOptions);
  this.options = $.extend(true, {}, this.defaultOptions, options);

  this.thumbSizeXY = this.options.thumbSizeXY;
  this.basket = new ConstructorBasket();
}
// show interface, init handlers; safe to call many times
ConstructorRenderer.prototype.init = function(options) {
  if (options) {
    this.options = $.extend(true, {}, this.options, options);
  }
  this.$thumbContainer = $(".pagescroll-images-container");
  this.$imageControlsContainer = $(".image-controls");
  this.$mainMenuContainer = $('#constructor-menu');
  this._initHandlers();
}
ConstructorRenderer.prototype.onReady = function() {
  // can be redefined in client code
}
// send post when a user clicks on image thumbnail
ConstructorRenderer.prototype.selectImage = function($thumbImage) {
  var params = {}, self = this;
  if ($thumbImage.attr("alt")) params.image = $thumbImage.attr("alt");
  //else if (image.data("uuid")) params.local_image = image.data("uuid");

  window.readyForBasket = false;
  $.post(window.route_set_image, params, function (a) { self.onSelectImage($thumbImage, a); }, "json");
}
// receive post after a user clicks on image thumbnail
ConstructorRenderer.prototype.onSelectImage = function($thumbImage, a) {
  if (a.result != "ok") return;
  if ($thumbImage.length) {
    $('.constructor-container').removeClass('constructor-empty-container');
    if ($(".pagescroll-images-container").data('jsp')) {
      $(".pagescroll-images-container").data('jsp').reinitialise();
    } else {
      $(".pagescroll-images-container").jScrollPane({});
    }
  }

  var objImg = $(a.image), self = this;
  if (a.source == "fotolia")$("#additional-price").show(); else $("#additional-price").hide();
  if (a.w != undefined)allowedWidth = a.w;
  if (a.h != undefined)allowedHeight = a.h;
  if (a.pixels != undefined)megapixels = Math.round(a.pixels / 1000) / 1000;
  $("#total-price").html(a.sum);
  $("#order-effect-title").html(a.effectTitle);

  $.extend(window.constructorCurrentImage, a);
  window.constructorShowImageQuality(window.constructorCurrentImage.quality);

  if ($thumbImage.data("uuid")) {
    thumbUuid = $thumbImage.data("uuid");
    objImg.src = '//:0';
    setTimeout(function() {
      self.showImage();
    }, 100);
    // Hide image controls available only to uploaded images
    $('.image-controls .photo-editor-button').hide();
  }
  $("#constructor-image").html(objImg);
  thumb = a.thumb;
  thumbId = $thumbImage.attr('alt');
  if (!$thumbImage.data("uuid")) {
    thumbUuid = null;
    // Show image controls available only to uploaded images
    showAviaryButton();
    this.init();
  }
  constructorUpdateMenu(a, $thumbImage);
  $("#constructor_d").val(a.degree);
  $('#constructor-image .splash, .pagescroll-images-container .splash').remove();
}
// send post when a user clicks on remove icon of image thumbnail
ConstructorRenderer.prototype.removeImage = function($thumbImage) {
  var self = this;
  var a = $thumbImage.parent().find("img");
  var canReload = !$thumbImage.hasClass('no-reload');
  $thumbImage.closest(".pagescroll-image").remove();
  $.post(route_remove_image, {image: a.attr("alt")}, function (b) {
    if (b.result == "ok" && b.reload) {
      var reloadFunc = function() {
        if (canReload) {
          //location.reload();
          location.href = route_constructor_new;
        } else {
          var d = $(".pagescroll-images-container");
          if (d.find(".image-line .pagescroll-image:first img").length) {
            d.find(".image-line .pagescroll-image:first img").trigger('click');
          } else {
            // update image controls when there is no images in the list (..or just refresh?)
            //location.reload();
            location.href = route_constructor_new;
          }
        }
      }
      var di = $('#dialog');
      if (di.is(':visible') && di.text()) {
        di.off( "dialogbeforeclose").one( "dialogbeforeclose", reloadFunc);
      } else {
        reloadFunc();
      }
    }
    $(".pagescroll-images-container").jScrollPane({});
    updateImageCounterValue(getImageCounterValue() - 1);
  }, "json");
}
// display current image in constructor
ConstructorRenderer.prototype.showImage = function (force) {
  var self = this;
  window.readyForBasket = false;
  if (typeof force === 'undefined') {
    force = this.forceImageRender; // false means don't request the same image
    this.forceImageRender = false;
  }
  if (window.jcrop_api !== undefined) {
    window.jcrop_api.destroy();
  }
  var cb = $("#cropbox");
  var ow = cb.css('max-width'),
    oh = cb.css('max-height'),
    r = constructorCurrentImage.degree;
  // compute image size
  var tnW = r % 180 ? constructorCurrentImage.thumbHeight : constructorCurrentImage.thumbWidth,
    tnH = r % 180 ? constructorCurrentImage.thumbWidth : constructorCurrentImage.thumbHeight;
  var tbSZ = configurator._computeThumbSize(tnW, tnH);
  var tbW = tbSZ[0],
    tbH = tbSZ[1];

  // Show image from client in-memory data
  if (thumbUuid) {
    var image = new Image();
    var data = local_uploading[thumbUuid];

    image.onload = function() {
      var imgData = self._renderLocalImage(image).toDataURL("image/jpeg");

      if (cb.attr("src") == imgData) { // the same image as displaying
        self._onLoadImage(this);
      } else {
        cb.removeAttr("style").removeAttr('width').removeAttr('height')
          .css({width: tbW + 'px', height: tbH + 'px'}).attr('width', tbW).attr('height', tbH)
          .one('load', function (evt) {
            self._onLoadImage(this, evt);
          })
          .attr("src", imgData);
      }

      $('#constructor-image .splash, .pagescroll-images-container .splash').remove();
    }
    image.src = data.data; // load originall image

    // Show image from the server
  } else {
    self._renderRemoteImage(constructorGetThumbUrl(r, force), force);
    $('#constructor-image .splash, .pagescroll-images-container .splash').remove();
  }
}
// change cropbox orientation: Landscape (default) or Portrait
ConstructorRenderer.prototype.changeOrientation = function(orientation, orientation_value) {
  if (this.options.orientation != orientation) {
    this.options.orientation = orientation;
    window.ratio_value = (typeof orientation_value === 'undefined') ? 1 / window.ratio_value : orientation_value;
    window.ratio = orientation;
    window.constructorCurrentImage.ratio = window.ratio;
    window.allowedHeight = [window.allowedWidth, window.allowedWidth = window.allowedHeight][0];
    this.forceImageRender = true;
  } else if (typeof orientation_value !== 'undefined') {
    window.ratio_value = orientation_value;
  }
}

ConstructorRenderer.prototype.changeProduct = function(data) {
  this._onChangeProduct(data);
}

ConstructorRenderer.prototype.changeSize = function(data) {
  window.allowedWidth = data.w;
  window.allowedHeight = data.h;
  window.pieces = data.pieces;
  window.ratio_value = this.options.orientation == 'Landscape' ? data.ratio_value : 1 / data.ratio_value;
  // TODO reinitialize constructor object without reloading
  /*if (data.productSlug == 'galerie-rahmen' || (data.productSlug == 'fotoleinwand' && (data.additional[2] || !data.additional[2] && wasMountMenu))) {
   location.reload();
   }*/

  if (constructorCurrentImage.thumbWidth > constructorCurrentImage.thumbHeight && window.ratio_value < 1 ||
    constructorCurrentImage.thumbWidth < constructorCurrentImage.thumbHeight && window.ratio_value > 1) {
    this.changeOrientation('Portrait');

    if (constructorCurrentImage.degree % 180) {
      this.changeOrientation(this.options.orientation == 'Portrait' ? 'Landscape' : 'Portrait');
    }
  } else if (window.ratio_value != 1 && window.isDiamond) {
    window.isDiamond = false;
    $("#constructor_r").val(0 + window.isDiamond);
  }

  constructorUpdateOrientationMenu();
  $.extend(constructorCurrentImage, data);
}

/**
 * Constructor class for Rahmen product
 * @constructor
 */
function ConstructorRahmenRenderer(options) {
  this.defaultOptions = {
    mount: {cornerImage: null, horizontalImage: null, verticalImage: null},
    productSize: [1, 1],
    rahmenName: null,
    rahmenZoom: 1
  };
  // duplicate option for mount
  if (typeof options.productSize !== 'undefined') this.defaultOptions.mount.productSize = options.productSize;
  else this.defaultOptions.mount.productSize = this.defaultOptions.productSize;
  // Call the parent constructor
  ConstructorRenderer.call(this, options);

  this.mountFrame = null;
}
ConstructorRahmenRenderer.prototype = Object.create(ConstructorRenderer.prototype);
ConstructorRahmenRenderer.prototype.init = function() {
  this.changeOrientation(this.options.orientation);
  ConstructorRenderer.prototype.init.call(this);
  this._fixAviaryMenu();
  this.showImage(true);
}

/**
 *  Private methods of ConstructorRenderer
 */
ConstructorRenderer.prototype._initHandlers = function() {
  var self = this;
  this.$thumbContainer.jScrollPane({});
  // image is loaded to constructor
  $("#cropbox").off('load')
    .one('load', function (evt) { self._onLoadImage(this, evt); })
    .each(function() { if (this.complete) $(this).trigger('load') });
  // click on thumb image in menu
  this.$thumbContainer.off('click')
    .on('click', '.pagescroll-image img', function() { self.selectImage($(this)); })
    .on("click", ".remove-image", function () { self.removeImage($(this)); });
  this.$mainMenuContainer
    .off('click', '.product-links').off('click', '.border-links').off('click', '.size-links')
    .on('click', '.product-links', function (evt) { self._selectMenuProduct($(this), evt); })
    .on('click', '.border-links', function (evt) { self._selectMenuBorder($(this), evt); })
    .on('click', '.size-links', function (evt) { self._selectMenuSize($(this), evt); });
}
ConstructorRenderer.prototype._onLoadImage = function(obj, evt) {
  constructorComputeThumbSize(window.constructorCurrentImage);
  initJcrop();
  window.readyForBasket = true;
  this.onReady();
}
ConstructorRenderer.prototype._computeThumbSize = function (naturalWidth, naturalHeight) {
  var thumbRatioX = this.thumbSizeXY[0] / naturalWidth,
    thumbRatioY = this.thumbSizeXY[1] / naturalHeight;
  var thumbRatio = Math.min(thumbRatioX, thumbRatioY);
  var imgW = Math.floor(naturalWidth * thumbRatio),
    imgH = Math.floor(naturalHeight * thumbRatio);

  return [imgW, imgH];
}
// click on another product type in menu
ConstructorRenderer.prototype._selectMenuProduct = function ($link, evt) {
  evt.preventDefault();
  if (!empty) {
    var self = this;
    window.readyForBasket = false;
    $("#const-products").find("li").removeClass("active-inner");
    $link.parent().addClass("active-inner");
    var wasSlug = constructorCurrentImage.productSlug;
    $.post(route_set_product, {product: $link.data("value"), border: $("#const-borders").find(".active-inner").find("a").data("value")}, function (a) {
      self.changeProduct(a);
      // TODO reinitialize constructor object without reloading
      if (wasSlug != constructorCurrentImage.productSlug &&
        (/*wasSlug == 'fotoleinwand' ||*/ wasSlug == 'galerie-rahmen' || wasSlug == 'galerie-rahmen-basic' ||
          /*constructorCurrentImage.productSlug == 'fotoleinwand' ||*/ constructorCurrentImage.productSlug == 'galerie-rahmen' || constructorCurrentImage.productSlug == 'galerie-rahmen-basic')) {
        location.reload();
      }
    }, "json");
  } else $("#constructor-menu").find(".active .constructor-menu-close").trigger("click");
}
// click on border in menu
ConstructorRenderer.prototype._selectMenuBorder = function ($link, evt) {
  evt.preventDefault();
  if (!empty) {
    var self = this;
    $("#const-borders").find("li").removeClass("active-inner");
    $link.parent().addClass("active-inner");
    $.post(route_set_product, {border: $link.data("value"), product: $("#const-products").find(".active-inner").find("a").data("value")}, function (a) { self.changeProduct(a); }, "json");
  } else $("#constructor-menu").find(".active .constructor-menu-close").trigger("click");
}
// click on another product size in menu
ConstructorRenderer.prototype._selectMenuSize = function ($link, evt) {
  evt.preventDefault();
  var self = this;
  if (!empty) {
    window.readyForBasket = false;
    $("#const-sizes").find(".product-table tr").removeClass("active");
    $link.addClass("active")
  }
  var wasMountMenu = $('#const-new-mount2').length > 0;
  $.post(route_set_sizes, {size: $link.attr("id").replace("size-", ""), border: $("#const-borders").find("li.active-inner a").data("value")}, function (d) {
    var f = $("#constructor-menu");
    f.find(".active .constructor-menu-close").trigger("click");
    if (d.result == "ok") {

      self.changeSize(d);

      isUpdateCropbox = true;
      self.showImage(true);
      constructorShowImageQuality(d.q);
      constructorShowMyProduct(d);
    }
  }, "json");
}
/**
 * TODO: replace/reinitialize constructor object
 */
ConstructorRenderer.prototype._onChangeProduct = function (j) {
  if (j.result != "ok") return;

  window.readyForBasket = false;
  var k = $("#const-sizesn"), h = this.$mainMenuContainer, f = $("#product_tabs");
  var oldRatio = ratio;
  allowedWidth = j.w;
  allowedHeight = j.h;
  ratio_value = this.options.orientation == 'Landscape' ? j.ratio_value : 1 / j.ratio_value;
  pieces = j.pieces;
  k.attr("class", "constructor-menu-content constructor-table-with-heading").addClass(j.className);
  constructorShowImageQuality(j.q);
  $("#new-size").html(j.new_size);
  $("#size-details").html(j.size);
  $("#order-size-title").html(j.new_size);
  $("#order-product-title").html(j.product);
  $("#product-title").html(j.product);
  $("#size-price").html(j.price);
  $("#total-price").html(j.sum);
  k.html(j.sizes);
  if (j.slug == "alu-dibond" || (j.slug == "alu-dibond-acryl-glass" || (j.slug == "forex" || j.slug == "acryl-glass"))) {
      $("#frame_warning").show();
  } else {
      $("#frame_warning").hide();
  }
  h.children(":gt(1)").remove();
  if (j.additional) for (var g in j.additional) h.children(":last").after(j.additional[g]);
  h.attr("class", "constructor-menu clearfix size" + h.find(".constructor-menu-header").length);

  if (j.ihr_product) {
    $('.ihr-table').replaceWith(j.ihr_product);
  }
  if (j.shipmentText) {
    $('#product-type-production_type-value').html(j.shipmentText);
  }

  $('#cropbox').removeAttr('style').removeAttr('width').removeAttr('height')
    .css({'max-width': this.thumbSizeXY[0] + 'px', 'max-height': this.thumbSizeXY[1] + 'px'});

  $.extend(constructorCurrentImage, j);
  if (oldRatio != ratio) {
    this.changeOrientation(oldRatio);
  }
  this.showImage();

  f.html(j.tabs_content);
  f.find(".content-tabs").tabs({selected: 2});
  $("#product-filter-form").find(":input").uniform();

  h.find(".active .constructor-menu-close").trigger("click");
}
// Can return URI to an image or base64 image DATA. @return Canvas
ConstructorRenderer.prototype._renderLocalImage = function (image) {
  var can = document.createElement('canvas'),
    //w = data.thumbWidth,
    //h = data.thumbHeight;
    w = image.naturalWidth,
    h = image.naturalHeight,
    r = constructorCurrentImage.degree;
  var size = Math.max(w, h);
  var center = Math.floor(size / 2),
    x = 0,
    y = 0;
  can.width = r % 180 ? h : w;
  can.height = r % 180 ? w : h;
  var context = can.getContext("2d");

  // rotation
  if (r != 0) {
    /*var canr = document.createElement('canvas');
    canr.width = size; canr.height = size;
    var conr = canr.getContext("2d");

    conr.save();
     conr.translate(center, center);
     conr.rotate(r * Math.PI/180);
     if (r == 90) { x = -center; y = center - h; }
     else if (r == 180) { x = -w/2; y = center - h; }
     else if (r == 270) { x = -w/2; y = -center; }
     conr.drawImage(image, x, y, w, h);
     conr.restore();
     context.drawImage(canr, 0, 0, can.width, can.height, 0, 0, can.width, can.height);
     */

    context.rotate(r * Math.PI/180);
    if (r == 180) { x = -w; y = -h; }
    else if (r == 90) { x = 0; y = -h; }
    else if (r == 270) { x = -w; y = 0; }
    context.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, x, y, w, h);
  } else {
    context.drawImage(image, 0, 0, w, h);
  }

  return can/*.toDataURL("image/jpeg")*/;
}
// Show image loaded from url
ConstructorRenderer.prototype._renderRemoteImage = function (url, force) {
  var cb = $("#cropbox"), self = this;
  var src = cb.attr("src");
  if (!force && src.indexOf("?") > 0) src = src.substring(0, src.indexOf("?"));
  if (src == url) {
    self._onLoadImage(this);
  } else {
    cb.one('load', function (evt) {
        self._onLoadImage(this, evt);
      })
      //.attr("src", constructorGetThumbUrl(r));
      .attr("src", url)
      .each(function() { if (this.complete) $(this).trigger('load') });
  }
}

ConstructorRahmenRenderer.prototype.changeOrientation = function(orientation) {
  ConstructorRenderer.prototype.changeOrientation.call(this, orientation);
  window.constructorCurrentImage.ratio = this.options.orientation;

  if (orientation === 'Landscape') {
    if (this.options.productSize[0] < this.options.productSize[1]) this.options.productSize.reverse();
    if (this.options.mount.productSize[0] < this.options.mount.productSize[1]) this.options.mount.productSize.reverse();
  } else {
    if (this.options.productSize[0] > this.options.productSize[1]) this.options.productSize.reverse();
    if (this.options.mount.productSize[0] > this.options.mount.productSize[1]) this.options.mount.productSize.reverse();
  }
}

ConstructorRahmenRenderer.prototype.setRahmenZoom = function(size) {
  this.options.rahmenZoom = size;
  this._updateMountOptions();
}

ConstructorRahmenRenderer.prototype.setRahmenName = function(name) {
  this.options.rahmenName = name;
  this._updateMountOptions();
}

ConstructorRahmenRenderer.prototype._updateMountOptions = function() {
  if (constructorCurrentImage.productSlug == 'galerie-rahmen' || constructorCurrentImage.productSlug == 'galerie-rahmen-basic') {
    this.options.mount = $.extend({}, this.options.mount, {
      cornerImage: '/images/rahmen/'+this.options.rahmenName+'_size_'+this.options.rahmenZoom+'_corners.png',
      horizontalImage: '/images/rahmen/'+this.options.rahmenName+'_size_'+this.options.rahmenZoom+'_horizontal.png',
      verticalImage: '/images/rahmen/'+this.options.rahmenName+'_size_'+this.options.rahmenZoom+'_vertical.png'
    });
  } else if (constructorCurrentImage.productSlug == 'fotoleinwand') {
    this.options.mount = $.extend({}, this.options.mount, {
      cornerImage: '/images/fotolram/'+this.options.rahmenName+'_size_'+this.options.rahmenZoom+'_corners.png',
      horizontalImage: '/images/fotolram/'+this.options.rahmenName+'_size_'+this.options.rahmenZoom+'_horizontal.png',
      verticalImage: '/images/fotolram/'+this.options.rahmenName+'_size_'+this.options.rahmenZoom+'_vertical.png'
    });
  }

  this.mountFrame = null;
}

ConstructorRahmenRenderer.prototype._showMountFrame = function() {
  if (!this.mountFrame) {
    this.mountFrame = new MountFrame();
    this.mountFrame.init(this.options.mount);
  }
  this.mountFrame.show();
}
ConstructorRahmenRenderer.prototype._onLoadImage = function() {
  this._showMountFrame();
  //ConstructorRenderer.prototype._onLoadImage.call(this);
  //constructorComputeThumbSize(window.constructorCurrentImage);
  //initJcrop();
  window.readyForBasket = true;
  this.onReady();
}
ConstructorRahmenRenderer.prototype._renderLocalImage = function (image) {
  var canv = ConstructorRenderer.prototype._renderLocalImage.call(this, image);
  return this._cropImageToProductRatio(canv);
}
ConstructorRahmenRenderer.prototype._renderRemoteImage = function (url, force) {
  var cb = $("#cropbox"), self = this;
//  var src = cb.attr("src");
  var src = window.constructorCurrentImage.image.replace(/.*src=(["'])(.*?)\1.*/, '$2');
  if (!force && src.indexOf("?") > 0) src = src.substring(0, src.indexOf("?"));
  if (src == url) {
    self._onLoadImage(this);
  } else {
    var img = new Image();
    img.onload = function() {
      imgData = self._cropImageToProductRatio(img).toDataURL("image/jpeg");
      cb.one('load', function (evt) {
          self._onLoadImage(this, evt);
        })
        .attr("src", imgData)
        .each(function() { if (this.complete) $(this).trigger('load') });
    };
    img.src = url;
  }
}
ConstructorRahmenRenderer.prototype._cropImageToProductRatio = function(img) {
  var iw, ih;
  if (img.tagName == 'CANVAS') {
    iw = img.width, ih = img.height;
  } else {
    iw = img.naturalWidth, ih = img.naturalHeight;
  }
  var imageRatio = iw / ih,
    productRatio = this.options.productSize[0] / this.options.productSize[1];

  if (imageRatio == productRatio) {
    return img.tagName == 'CANVAS' ? img : img.src;
  }

  var width, height;
  if (productRatio < imageRatio) {
//    width = iw;
//    height = width / productRatio;
    height = ih;
    width = height * productRatio;
  } else {
//    height = ih;
//    width = height * productRatio;
    width = iw;
    height = width / productRatio;
  }

  var x1 = Math.abs(Math.round((width - iw) / 2)),
      y1 = Math.abs(Math.round((height - ih) / 2));
  // Update crop form values for basket
  this.basket.setImageCrop({
    x1: x1, y1: y1,
    x2: Math.round(x1+width - 1), y2: Math.round(y1+height - 1),
    w: Math.round(width), h: Math.round(height)
  });

  var can = document.createElement('canvas');
  can.width = width; can.height = height;
  var context = can.getContext("2d");
  context.drawImage(img, 0, 0, iw, ih, -x1, -y1, iw, ih);

  return can;
}
ConstructorRahmenRenderer.prototype._onChangeProduct = function (j) {
  ConstructorRenderer.prototype._onChangeProduct.call(this, j);
  this.options.productSize = j.productSize;
  this.options.mount.productSize = j.productSize;

  this._fixAviaryMenu();
  //console.log(j);
}
ConstructorRahmenRenderer.prototype._fixAviaryMenu = function () {
  if (typeof this.aviaryOrigConfig === 'undefined') this.aviaryOrigConfig = window.aviary.config;

  var landrat = ratio_value;
  if (ratio !== 'Landscape') landrat = 1 / landrat;
//  landrat = landrat.toFixed(5);console.log(landrat);
  var rat = rationalize(bigRat(landrat),0.01).toString().replace('/', ':');
  window.aviary.init({
    'cropPresets': [rat/*, rat.split(':').reverse().join(':')*/],
    'tools': 'crop,' + this.aviaryOrigConfig.tools
  });
}
ConstructorRahmenRenderer.prototype.changeSize = function(data) {
  if (!data.productSize) return;

  ConstructorRenderer.prototype.changeSize.call(this, data);

  this.options.productSize = data.productSize;
  this.options.mount.productSize = data.productSize;
  this.changeOrientation(this.options.orientation);
  this.setRahmenZoom(data.rahmen_zoom);

  this._fixAviaryMenu();
}

ConstructorRahmenRenderer.prototype.shutdown = function() {
  if (typeof this.aviaryOrigConfig !== 'undefined') window.aviary.init(this.aviaryOrigConfig);
}

/**
 * Static functions
 */

ConstructorRenderer.createInstance = function(currentImageInfo) {

}

/**
 * Basket-related functions
 */

function ConstructorBasket(options) {

}

ConstructorBasket.prototype.setImageCrop = function(values) {
  $.each(values, function(k, v) {
    $("#constructor_" + k).val(v);
  });
}
